import { useEffect, useMemo, useRef, useState } from "react";
import { CgCheck } from "react-icons/cg";
import useGetSkills from "src/hooks/useGetSkills";

export default function SkillSearchInput({ selectedSkills, onSkillSelect }) {
  const { loading, error, skills, retry } = useGetSkills();
  const inputRef = useRef();
  const popoverRef = useRef();
  const popoverElement = popoverRef.current;
  const inputElement = inputRef.current;

  const [filterInputValue, setFilterInputValue] = useState("");

  const filteredSkillsByInput = useMemo(() => {
    if (filterInputValue.trim() == "") return [];
    return skills.filter((each) =>
      each.name.toLowerCase().includes(filterInputValue.toLowerCase())
    );
  }, [filterInputValue, skills]);

  useEffect(() => {
    const handleFocusIn = (event) => {
      // TODO: Implement
    };

    const handleFocusOut = (event) => {
      // TODO: Implement
    };

    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
    };
  }, []);

  return (
    <div className="relative w-full">
      <input
        ref={inputRef}
        id="skill"
        name="skill"
        type="search"
        value={filterInputValue}
        onChange={(e) => {
          setFilterInputValue(e.currentTarget.value);
        }}
        placeholder="Type here to search..."
        className="text-sm w-full text-gray-700 flex-1 p-2 px-4 rounded-full outline-secondary/20 dfocus:outline-none"
      />

      {filterInputValue.trim() !== "" && (
        <div
          aria-modal={"true"}
          className="absolute top-14 max-h-[300px] pb-10"
          ref={popoverRef}
        >
          <div className="flex flex-col h-full overflow-x-auto rounded-xl bg-white shadow-xl border-2">
            {filteredSkillsByInput.map((skill, index) => {
              const selected = selectedSkills.find(each => each.id === skill.id)

              return (
                <button
                  key={index}
                  onClick={() => {
                    inputElement.focus();
                    !selected && onSkillSelect(skill);
                  }}
                  type="button"
                  className="skillItem p-2  flex items-center gap-2 hover:bg-surface cursor-pointer text-sm"
                >
                  <p className="flex-1 text-start pe-20">{skill.name}</p>
                  {selected && <CgCheck className="text-lg" />}
                </button>
              );
            })}

            {filteredSkillsByInput.length === 0 &&
              filterInputValue.trim() !== "" && (
                <div className="max-w-3/5 mx-auto text-center text-sm p-2 text-gray-700">
                  <p>Skill not found...</p>
                </div>
              )}
          </div>
        </div>
      )}
    </div>
  );
}
